import type { TransaccionRecurrente } from '../types';

type Periodicidad = TransaccionRecurrente['periodicidad'];

/** Suma un periodo a la fecha (mes, semana, día laborable…). */
export function avanzarFecha(fecha: Date, periodicidad: Periodicidad): Date {
  const d = new Date(fecha);
  if (periodicidad === 'diario')      d.setDate(d.getDate() + 1);
  else if (periodicidad === 'laboral') {
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
  }
  else if (periodicidad === 'semanal')    d.setDate(d.getDate() + 7);
  else if (periodicidad === 'mensual')    d.setMonth(d.getMonth() + 1);
  else if (periodicidad === 'trimestral') d.setMonth(d.getMonth() + 3);
  else if (periodicidad === 'semestral')  d.setMonth(d.getMonth() + 6);
  else if (periodicidad === 'anual')      d.setFullYear(d.getFullYear() + 1);
  return d;
}

/**
 * Próxima fecha tras pulsar «Ejecutar». Lo ejecutado cuenta siempre como la
 * ejecución prevista, así que se avanza al menos un periodo aunque se adelante
 * (nómina del 29 ejecutada el 28 → la siguiente es el 29 del mes que viene).
 * Si había periodos atrasados, se salta hasta el primero posterior a hoy.
 */
export function proximaTrasEjecutar(proximaFecha: Date, periodicidad: Periodicidad, ahora = new Date()): Date {
  const finHoy = new Date(ahora); finHoy.setHours(23, 59, 59, 999);
  let proxima = avanzarFecha(new Date(proximaFecha), periodicidad);
  while (proxima <= finHoy) proxima = avanzarFecha(proxima, periodicidad);
  return proxima;
}
